import { connect } from 'react-redux';
import { AuthenticatedUser, fetchAccessTokenSilently, State } from '~/AccessToken';

import UserNavigationItem from './UserNavigationItem';

function mapStateToProps(state: { accessToken: State }): {
	user: AuthenticatedUser | null;
} {
	const { accessToken } = state.accessToken;

	return {
		user: accessToken !== null ? accessToken.user : null,
	};
}

const actions = {
	onFetch: fetchAccessTokenSilently,
};

export default connect(mapStateToProps, actions)(UserNavigationItem);
